
export const TitleText=()=>{
    
    return(
        <div className=" __container title-text">
            <div className="title-text_placeholder">
                <p className="title-text_header">
                    <span className="title-text_logo">CREATE<span className="x">X</span></span>CONSTRUCTION
                </p>
                <span className="title-text_description">
                    Cras ultrices leo vitae non viverra. Fringilla nisi quisque consequat, dignissim vitae proin ipsum sed. Pellentesque nec turpis purus eget pellentesque integer ipsum elementum felis.
                </span>
            </div>
            <div className="title-text_button-placeholder">
                <a><p>Learn more about us</p></a>
                <a><p>SUBMIT REQUEST</p></a>
            </div>
        </div>
    )
}